import { useMemo, useState } from 'react';
import { FlowTrigger } from '../constants/flowTriggers';
import { getStepTotal } from '../constants/flowSteps';

export const useFlowStepNavigation = (triggerType: FlowTrigger) => {
    const [currentStep, setCurrentStep] = useState(1);
    const [submittedName, setSubmittedName] = useState('New Email Flow');

    const stepTotal = useMemo(() => getStepTotal(triggerType), [triggerType]);

    const goToNextStep = () => {
        setCurrentStep(prev => Math.min(prev + 1, stepTotal));
    };

    const goToPreviousStep = () => {
        setCurrentStep(prev => Math.max(prev - 1, 1));
    };

    const isFirstStep = currentStep === 1;
    const isLastStep = currentStep === stepTotal;

    return {
        currentStep,
        stepTotal,
        submittedName,
        setSubmittedName,
        goToNextStep,
        goToPreviousStep,
        isFirstStep,
        isLastStep,
    };
};
